import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateWithFrom } from '../utils/navigationUtils';
import { sanitizeString } from '../utils/security';

const safeText = (value) => sanitizeString(value ?? '');

const getStatusBadge = (durum) => {
  const statusColors = {
    'Randevu Bekleniyor': '#f59e0b',
    'Randevu Tarihi Bekleniyor': '#6366f1',
    'İşlemde': '#10b981',
    'Randevu Tamamlandı': '#059669',
    'Randevu İptal Edildi': '#ef4444',
  };
  const color = statusColors[durum] || '#64748b';
  return (
    <div
      style={{
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500,
        background: `${color}15`,
        color,
        border: `1px solid ${color}40`,
        whiteSpace: 'nowrap',
        display: 'inline-block',
      }}
    >
      {durum || '—'}
    </div>
  );
};

const TpAppointmentListTable = ({ appointments = [], emptyMessage = 'Randevu bulunamadı' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!appointments.length) {
    return (
      <div className="empty-state" style={{ padding: '32px', textAlign: 'center' }}>
        <i className="fas fa-calendar-times" style={{ fontSize: '28px', color: 'var(--text-light)', marginBottom: '10px' }} />
        <div style={{ color: 'var(--text-gray)', fontSize: '14px' }}>{emptyMessage}</div>
      </div>
    );
  }

  const handleRowClick = (appointmentId) => {
    if (!appointmentId) return;
    navigateWithFrom(navigate, `/appointments/${appointmentId}`, location);
  };

  return (
    <div className="table-container">
      <table className="admins-table tp-appointment-table">
        <thead>
          <tr>
            <th>Müşteri</th>
            <th>Telefon</th>
            <th>Randevu Tarihi</th>
            <th>Saat</th>
            <th>Durum</th>
            <th className="islemler-sutunu">Detay</th>
          </tr>
        </thead>
        <tbody>
          {appointments.map((appointment) => {
            const appointmentId = appointment.id || appointment._id;
            const serviceRecord = appointment.servisKaydi || appointment.servisKaydiId || {};
            const customer = serviceRecord.musteri || serviceRecord.musteriId || {};
            const customerName = `${customer.adi || customer.name || ''} ${customer.soyadi || customer.surname || ''}`.trim() || '—';
            const customerPhone = customer.telefon || customer.phone || customer.gsm || '—';
            const appointmentDate = appointment.randevuTarihi
              ? new Date(appointment.randevuTarihi).toLocaleDateString('tr-TR', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })
              : '—';

            return (
              <tr
                key={appointmentId}
                className="tp-appointment-row"
                onClick={() => handleRowClick(appointmentId)}
                style={{ cursor: appointmentId ? 'pointer' : 'default' }}
              >
                <td>{safeText(customerName)}</td>
                <td>{safeText(customerPhone)}</td>
                <td>{appointmentDate}</td>
                <td>{appointment.randevuSaati || appointment.randevuSaatAraligi || '—'}</td>
                <td className="status-cell">{getStatusBadge(appointment.durum)}</td>
                <td className="islemler-sutunu" onClick={(e) => e.stopPropagation()}>
                  {appointmentId && (
                    <button
                      type="button"
                      className="category-action-btn edit-btn"
                      onClick={() => handleRowClick(appointmentId)}
                      title="Randevu detayı"
                    >
                      <i className="fas fa-eye" />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TpAppointmentListTable;
